import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function KeyValueList({ items, className, columns = 1 }: { items: Array<[label: string, value: ReactNode]>; className?: string; columns?: 1 | 2 | 3 }) {
  return (
    <dl className={cn("grid gap-x-6", columns === 2 && "sm:grid-cols-2", columns === 3 && "sm:grid-cols-3", className)}>
      {items.map(([label, value]) => (
        <div key={label} className="flex min-w-0 items-baseline justify-between gap-3 border-b border-dashed py-1.5 last:border-b-0">
          <dt className="shrink-0 text-muted-foreground text-xs">{label}</dt>
          <dd className="min-w-0 truncate text-right">{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function Section({
  title,
  actions,
  children,
  className,
  id,
}: {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section className={cn("rounded-md border bg-card", className)} aria-labelledby={id}>
      <header className="flex min-h-9 items-center justify-between gap-2 border-b px-3 py-1.5">
        <h2 id={id} className="font-semibold text-xs uppercase tracking-wide">
          {title}
        </h2>
        {actions}
      </header>
      <div className="p-3">{children}</div>
    </section>
  );
}
